module.exports = __webpack_public_path__ + "img/0301.4aac02d4.png";